import React from 'react';
import CampoComboParametro from '../../UI/campos/CampoComboParametro.js';
import CampoEditableNumero from '../../UI/campos/CampoEditableNumero.js';
import CampoEditableCheck from '../../UI/campos/CampoEditableCheck.js';
import CampoOptionsTipoEtapa from '../../UI/campos/CampoOptionsTipoEtapa.js';
import CampoOptionsPartidosDefinicion from '../../UI/campos/CampoOptionsPartidosDefinicion.js';
import * as Campos from '../../constantes/Campos.js';
import * as TipoParametro from '../../constantes/TipoParametro.js';
import styles from '../EditarItemLista.module.css';

const CamposTorneoEtapa = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  const esDefinicion = item?.definicion === true;

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>Orden</td>
        <td className={`${styles.valor}`}>
          <CampoEditableNumero
            estilo={`${styles.campoNumero}`}
            editar={editar}
            nombre={Campos.TorneoEtapa.ORDEN}
            valor={item?.orden}
            largo={2}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Etapa</td>
        <td className={`${styles.valor}`}>
          <CampoComboParametro
            editar={editar}
            nombre={Campos.TorneoEtapa.ETAPA}
            tipoParametro={TipoParametro.ETAPA_TORNEO}
            valor={item?.etapa}
            incluirNulo={false}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      <tr>
        <td className={`${styles.titulo}`}>Tipo</td>
        <td className={`${styles.valor}`}>
          <CampoOptionsTipoEtapa
            estilo={`${styles.options}`}
            editar={editar}
            nombre={Campos.TorneoEtapa.DEFINICION}
            valor={item?.definicion}
            onChange={onCampoChange}
          />
        </td>
      </tr>
      {esDefinicion ? (
        <React.Fragment>
          <tr>
            <td className={`${styles.titulo}`}>Partidos</td>
            <td className={`${styles.valor}`}>
              <CampoOptionsPartidosDefinicion
                estilo={`${styles.options}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.CANTIDAD_RUEDAS}
                valor={item?.cantidadRuedas}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Llaves</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                estilo={`${styles.campoNumero}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.CANTIDAD_CRUCES}
                valor={item?.cantidadCruces}
                largo={2}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Dividida en Zonas (opcional)</td>
            <td className={`${styles.valor}`}>
              <CampoEditableCheck
                estilo={`${styles.campoCheck}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.ZONAS}
                checked={item?.zonas}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <tr>
            <td className={`${styles.titulo}`}>Ruedas</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                estilo={`${styles.campoNumero}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.CANTIDAD_RUEDAS}
                valor={item?.cantidadRuedas}
                largo={1}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Fechas</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                estilo={`${styles.campoNumero}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.CANTIDAD_FECHAS}
                valor={item?.cantidadFechas}
                largo={2}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Partidos por Fecha</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                estilo={`${styles.campoNumero}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.CANTIDAD_CRUCES}
                valor={item?.cantidadCruces}
                largo={2}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Dividida en Zonas</td>
            <td className={`${styles.valor}`}>
              <CampoEditableCheck
                estilo={`${styles.campoCheck}`}
                editar={editar}
                nombre={Campos.TorneoEtapa.ZONAS}
                checked={item?.zonas}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CamposTorneoEtapa;
